var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import authnApi from "apis/eduidAuthn";
import { bankIDApi } from "apis/eduidBankid";
import { eidasApi } from "apis/eduidEidas";
import { frejaeIDApi } from "apis/eduidFrejaeID";
import { orcidApi } from "apis/eduidOrcid";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { ACCOUNT_PATH, CHPASS_BASE_PATH, IDENTITY_PATH, SECURITY_PATH, START_PATH } from "helperFunctions/paths";
import { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { showNotification } from "slices/Notifications";
const actionToRoute = {
    verifyIdentity: IDENTITY_PATH,
    verifyCredential: SECURITY_PATH,
    changepwAuthn: CHPASS_BASE_PATH,
    terminateAccountAuthn: "/",
    addSecurityKeyAuthn: SECURITY_PATH,
    removeSecurityKeyAuthn: SECURITY_PATH,
    changeSecurityPreferencesAuthn: SECURITY_PATH,
    removeIdentity: IDENTITY_PATH,
    connectOrcid: ACCOUNT_PATH,
};
function getRoute(frontend_action) {
    var _a;
    return (_a = actionToRoute[frontend_action]) !== null && _a !== void 0 ? _a : START_PATH;
}
export function ExternalReturnHandler() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const app_loaded = useAppSelector((state) => state.config.is_app_loaded);
    const [authnGetStatus] = authnApi.useLazyAuthnGetStatusQuery();
    const [bankIDGetStatus] = bankIDApi.useLazyBankIDGetStatusQuery();
    const [eidasGetStatus] = eidasApi.useLazyEidasGetStatusQuery();
    const [frejaeIDGetStatus] = frejaeIDApi.useLazyFrejaeIDGetStatusQuery();
    const [orcidGetStatus] = orcidApi.useLazyOrcidGetStatusQuery();
    const getStatusAction = useCallback((app_name) => {
        var _a;
        const actions = {
            eidas: eidasGetStatus,
            samleid: eidasGetStatus,
            bankid: bankIDGetStatus,
            freja_eid: frejaeIDGetStatus,
            orcid: orcidGetStatus,
        };
        return (_a = actions[app_name !== null && app_name !== void 0 ? app_name : ""]) !== null && _a !== void 0 ? _a : authnGetStatus;
    }, [eidasGetStatus, bankIDGetStatus, frejaeIDGetStatus, orcidGetStatus, authnGetStatus]);
    const processStatus = useCallback((status) => {
        if (status.status) {
            dispatch(showNotification({ message: status.status, level: status.error ? "error" : "info" }));
        }
        navigate(status.frontend_action ? getRoute(status.frontend_action) : START_PATH);
    }, [dispatch, navigate]);
    const fetchStatus = useCallback((authn_id) => __awaiter(this, void 0, void 0, function* () {
        const action = getStatusAction(params.app_name);
        const response = yield action({ authn_id });
        if (response.isSuccess) {
            processStatus(response.data.payload);
        }
    }), [params.app_name, getStatusAction, processStatus]);
    useEffect(() => {
        if (app_loaded && params.authn_id) {
            fetchStatus(params.authn_id);
        }
    }, [params, app_loaded, fetchStatus]);
    return null;
}
